import React from 'react';
import {message, Select} from 'antd';
import {useLazyQuery, useMutation} from '@apollo/client';
import {useTranslation} from 'react-i18next';
import {
  ComplaintTaskAssignCandidatesResponse,
  GET_COMPLAINT_TASK_ASSIGN_CANDIDATES,
} from '../../../../graphql/complaintTask/queries';
import {ASSIGN_COMPLAINT_TASK} from '../../../../graphql/complaintTask/mutations';
import {ComplaintTaskRow} from '../../../../graphql/complaintTask/types';
import {translateGraphQLError} from '../../../../utils/graphqlUtils';
import {roleLabel} from '../complaintTaskUtils';

/**
 * 承接人列行内指派 / 转派：展开下拉时才拉候选人（按登录人范围），选中即生效（PRD：不用进详情页）。
 */
const AssigneeSelect: React.FC<{row: ComplaintTaskRow; onAssigned: () => void}> = ({row, onAssigned}) => {
  const {t} = useTranslation();
  const [loadCandidates, {data, loading}] = useLazyQuery<ComplaintTaskAssignCandidatesResponse>(
    GET_COMPLAINT_TASK_ASSIGN_CANDIDATES, {fetchPolicy: 'network-only'});
  const [assign, {loading: assigning}] = useMutation(ASSIGN_COMPLAINT_TASK);

  const current = row.assigneeAccountId
    ? [{value: row.assigneeAccountId, label: `${row.assigneeName ?? ''}（${roleLabel(row.assigneeRole)}）`}]
    : [];
  const options = (data?.complaintTaskAssignCandidates ?? []).map((c) => ({
    value: c.accountId,
    label: `${c.name}（${roleLabel(c.roleCode)}）`,
  }));

  const onChange = async (assigneeId: number) => {
    try {
      await assign({variables: {taskId: row.taskId, assigneeId}});
      message.success(t('complaintTask.assign.success'));
      onAssigned();
    } catch (e) {
      message.error(translateGraphQLError(e, 'complaintTask.errors.assignFailed'));
    }
  };

  return (
    <Select
      className="w-48"
      showSearch
      optionFilterProp="label"
      value={row.assigneeAccountId ?? undefined}
      placeholder={t('complaintTask.assign.placeholder')}
      loading={loading || assigning}
      options={[...current, ...options]}
      onDropdownVisibleChange={(open) => open && loadCandidates({variables: {taskId: row.taskId}})}
      onChange={onChange}
    />
  );
};

export default AssigneeSelect;
